import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
  ICreatePaymentSessionRequest,
  ICreatePaymentSessionResponse,
} from '../types';

export const PaymentApi = Symbol('PaymentApi');

export interface PaymentApi {
  createPaymentSession(
    params: ICreatePaymentSessionRequest,
  ): Promise<ICreatePaymentSessionResponse | null>;
}

@injectable()
export class PaymentApiImpl extends PsHttpService implements PaymentApi {
  get options() {
    return {
      baseURL: `${import.meta.env.VITE_ACCOUNT_SERVICE_URI}`,
    };
  }

  createPaymentSession(params: ICreatePaymentSessionRequest) {
    return this.post<
      PatSnapCommonResponseData<ICreatePaymentSessionResponse>
    >({
      url: '/user-service/payment/stripe/checkout-session',
      method: 'POST',
      data: params,
    })
      .then((res) => {
        const data = (res as any)?.data ?? res;
        return data as ICreatePaymentSessionResponse;
      })
      .catch((err) => {
        console.error('[PaymentApi] createPaymentSession failed', err);
        return null;
      });
  }
}
